// Source unique de vérité pour les styles musicaux, partagée entre :
//   - la création de festival (CreateFestivalPage — `musicStyles`)
//   - le profil exposant (MyStandPage — styles préférés)
//   - le matching de pertinence (matching/relevance.ts — critère « thème »)
// Les `id` doivent rester stables : ils sont persistés en Firestore.

export interface MusicStyle {
  id: string;
  label: string;
}

export const MUSIC_STYLES: MusicStyle[] = [
  { id: 'electro', label: 'Électronique' },
  { id: 'rock', label: 'Rock / Métal' },
  { id: 'pop', label: 'Pop' },
  { id: 'rap', label: 'Rap / Hip-Hop' },
  { id: 'jazz', label: 'Jazz / Blues' },
  { id: 'reggae', label: 'Reggae' },
  { id: 'world', label: 'Musiques du Monde' },
  { id: 'mixed', label: 'Mixte / Éclectique' },
];

export const ELECTRO_SUBSTYLES: MusicStyle[] = [
  { id: 'techno', label: 'Techno' },
  { id: 'house', label: 'House' },
  { id: 'trance', label: 'Trance' },
  { id: 'bass', label: 'Bass Music' },
  { id: 'downtempo', label: 'Downtempo' },
  { id: 'techhouse', label: 'Tech House' },
  { id: 'electro', label: 'Electro' },
  { id: 'afrohouse', label: 'Afro House' },
  { id: 'industrial', label: 'Industrial' },
  { id: 'acid', label: 'Acid' },
];

// `mixed` = l'exposant/festival est ouvert à tous les styles → matche tout le monde.
export const MUSIC_STYLE_WILDCARD = 'mixed';

const LABEL_BY_ID: Record<string, string> = Object.fromEntries(
  [...MUSIC_STYLES, ...ELECTRO_SUBSTYLES].map(s => [s.id, s.label])
);

export function musicStyleLabel(id: string): string {
  return LABEL_BY_ID[id] || id;
}
